'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const d3=require('d3');
const _=require('pulsar-utils/dist-es6/_');
const StatisticsPanelHelpers=require('../../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const BaseTwoAxisGraphPanelDirective=require('../../../../../dist-es6/client/directives/statisticsPanels/baseTwoAxisGraphPanelDirective');
const BaseTwoAxisGraphPanelDirectiveController=BaseTwoAxisGraphPanelDirective.DirectiveController;let

TotalIncidentsGraphPanelDirective=function(_BaseTwoAxisGraphPane){_inherits(TotalIncidentsGraphPanelDirective,_BaseTwoAxisGraphPane);function TotalIncidentsGraphPanelDirective(){_classCallCheck(this,TotalIncidentsGraphPanelDirective);return _possibleConstructorReturn(this,_BaseTwoAxisGraphPane.apply(this,arguments))}_createClass(TotalIncidentsGraphPanelDirective,[{key:'controller',get:function()
{return TotalIncidentsGraphPanelDirectiveController}}]);return TotalIncidentsGraphPanelDirective}(BaseTwoAxisGraphPanelDirective);


const MaxNumTicks=5;
const BarWidth=16;let

TotalIncidentsGraphPanelDirectiveController=function(_BaseTwoAxisGraphPane2){_inherits(TotalIncidentsGraphPanelDirectiveController,_BaseTwoAxisGraphPane2);
function TotalIncidentsGraphPanelDirectiveController($scope,$timeout,$element,elementService){_classCallCheck(this,TotalIncidentsGraphPanelDirectiveController);var _this2=_possibleConstructorReturn(this,
_BaseTwoAxisGraphPane2.call(this,$scope,$timeout,$element,elementService));

_this2._drawTickLinesOnTopOfGraph=!0;
_this2._allMonthBucketsForBackground=d3.time.month.utc.range(_this2.graphXAxisDomain[0],_this2.graphXAxisDomain[1]);return _this2;
}TotalIncidentsGraphPanelDirectiveController.prototype.


_setupGraphs=function _setupGraphs(){
if(!_.exists(this._backgroundBarGroup)){
this._backgroundBarGroup=this._svgContainer.
insert('g','.graph-area').
attr({
class:'background-bars',
transform:`translate(${this._axisLabelMargins.left},${this._axisLabelMargins.top})`});

}

this._numYAxisTicks=Math.min(this.graphYAxisDomain[1],MaxNumTicks);
};TotalIncidentsGraphPanelDirectiveController.prototype.






_getAggregateBucketViewData=function _getAggregateBucketViewData(monthViewData){var _this3=this;
const getOnScreenHeight=this._yScale.copy().rangeRound(this._yScale.range().reverse());

return _(monthViewData).keys().map(function(monthName){
const x=_this3._xScale(monthViewData[monthName].monthStart);
const heightBelow=getOnScreenHeight(monthViewData[monthName].Below+monthViewData[monthName].NotApplicable);
const heightAt=getOnScreenHeight(monthViewData[monthName].At);
const heightAbove=getOnScreenHeight(monthViewData[monthName].Above);

return[{
x:x,
height:heightAbove,
y:_this3.graphAreaDimensions.height-heightAbove,
class:'above-threshold',
id:`${monthName}_0`},
{
x:x,
height:heightAt,
y:_this3.graphAreaDimensions.height-(heightAt+heightAbove),
class:'at-threshold',
id:`${monthName}_1`},
{
x:x,
height:heightBelow,
y:_this3.graphAreaDimensions.height-(heightBelow+heightAt+heightAbove),
id:`${monthName}_2`}];

}).flatten().value();
};TotalIncidentsGraphPanelDirectiveController.prototype.





_setupInitialState=function _setupInitialState(){

const aggregateBucketViewData=this._getAggregateBucketViewData(this.context);

this._backgroundBars=this._backgroundBarGroup.
selectAll('rect').
data(this._allMonthBucketsForBackground,function(d){return d.getTime()});

this._backgroundBars.
enter().
append('rect').
attr({
width:this.barWidth,
y:0,
height:this.graphAreaDimensions.height});


this._backgroundBars.
exit().
remove();

this._aggregateBars=this._graphAreaGroup.
selectAll('rect').
data(aggregateBucketViewData,function(d){return d.id});

this._aggregateBars.
enter().
append('rect').
attr({
width:this.barWidth,
y:this.graphAreaDimensions.height,
fill:`url(#gradient-${this.panelId})`,
"clip-path":`url(#clip-path-${this.panelId})`});


this._aggregateBars.
exit().
remove();

this._yAxisGroup.classed({
y:!0,
axis:!0});

};TotalIncidentsGraphPanelDirectiveController.prototype.


_updateState=function _updateState(isResizing){var _this4=this;
const noAnimations=this.preventAnimations||isResizing;

const backgroundBarsWithOrWithoutTransition=noAnimations?
this._backgroundBars:
this._backgroundBars.transition().duration(StatisticsPanelHelpers.DefaultTransitionDuration);

backgroundBarsWithOrWithoutTransition.
attr({
x:function(d){return _this4._xScale(d)-_this4.barWidth/2},
width:this.barWidth,
height:this.graphAreaDimensions.height});


const barsWithOrWithoutTransition=noAnimations?
this._aggregateBars:
this._aggregateBars.transition().duration(StatisticsPanelHelpers.DefaultTransitionDuration);

barsWithOrWithoutTransition.
attr({
width:this.barWidth,
height:function(b){return b.height},
y:function(b){return b.y},
x:function(b){return b.x-_this4.barWidth/2},
class:function(b){return b.class}});

};_createClass(TotalIncidentsGraphPanelDirectiveController,[{key:'barWidth',get:function(){return BarWidth}}]);return TotalIncidentsGraphPanelDirectiveController}(BaseTwoAxisGraphPanelDirectiveController);






module.exports=TotalIncidentsGraphPanelDirective;
//# sourceMappingURL=totalIncidentsGraphPanelDirective.js.map
